<template>
      <b-card class="col-12" title="Subscription">
        <br />
        <center v-if="$user.main_account==true && $active_account==null">
          <h1>Choose a plan</h1>
        </center>
        <center v-else>
          <h1>Choose your plan</h1>
        </center>
        <br />
        <center>
        <b-row class="justify-content-md-center">
          
          <SubscriptionElement :current_user_id="current_user_id?current_user_id:$user.id" v-for="subscription in subscriptions" :key="subscription.id" :subscription="subscription" :current_subscription="current_subscription" />
        
        </b-row>
      </center>
      </b-card>
  </template>
  
  <script>
  import {BModal, BButton, BOverlay, BRow, BCol, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
  import SubscriptionElement from './SubscriptionElement.vue'
  export default {
    name: 'SubscriptionPopup',
    props:['current_subscription','subscriptions','current_user_id'],
    components: {
      BCard,
      BCardText,
      BRow,
      BCol,
      BModal,
      BButton,
      SubscriptionElement,
    }
  }
  </script>
  
  <style scoped>

  </style>